import React from 'react'

import Text from '../../ui/Text'

import { Column, Row, ChangePassword } from './UserDetails.styling'

type UserDetailsPasswordProps = {
    onChange: (password: string) => void
    openPasswordChange: boolean
    setOpenPasswordChange: () => void
}

const UserDetailsPassword = React.memo(function UserDetailsPassword({
    onChange,
    openPasswordChange,
    setOpenPasswordChange,
}: UserDetailsPasswordProps): React.ReactElement {
    return (
        <>
            <ChangePassword className="pointer" onClick={() => setOpenPasswordChange()} data-testid="change-password">
                <Text code="lblChangingPassword" />
                {!openPasswordChange && <span className="fa fa-caret-right"></span>}
                {openPasswordChange && <span className="fa fa-caret-down"></span>}
            </ChangePassword>
            {openPasswordChange && (
                <Row>
                    <Column data-testid="newPassword">
                        <Text code="lblPasswordField" />
                        <input
                            className="form-control"
                            id="newPassword"
                            type="password"
                            data-testid="newPassword-input"
                        ></input>
                    </Column>
                    <Column data-testid="passwordCompare">
                        <Text code="lblConfirmPasswordField" />
                        <input
                            className="form-control"
                            onChange={(e) => onChange(e.target.value)}
                            type="password"
                            data-testid="passcordCompare-input"
                        ></input>
                    </Column>
                </Row>
            )}
        </>
    )
})

export default UserDetailsPassword
